<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <p class="order-title-boxs"><span class="blueBlock"></span><i>基本信息</i></p>
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            label-width="140px"
            label-position="left"
          >
                <el-form-item
                  class="el-form-item-add"
                  ref="customerName"
                  label="客户姓名："
                  prop="customerName"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.customerName" placeholder="请输入客户姓名" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="mobile"
                  label="电话号码："
                  prop="mobile"
                  :rules="$rules.phone"
                >
                  <el-input v-model="form.mobile" placeholder="请输入电话号码"></el-input>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="gender"
                  label="性别："
                  prop="gender"
                  :rules="$rules.required"
                >
                  <el-radio-group v-model="form.gender">
                    <el-radio label="male">男</el-radio>
                    <el-radio label="famale">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="docNo"
                  label="卡号："
                  prop="docNo"
                  :rules="$rules.zeroNumed"
                >
                  <el-input v-model="form.docNo" placeholder="请输入卡号"></el-input>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="repairCateId"
                  label="分类："
                  prop="repairCateId"
                  :rules="$rules.changeIred"
                >
                  <el-select v-model="form.repairCateId" class="width200">
                    <el-option
                      v-for="(item,index) in categoryOption"
                      :key="index"
                      :label="item.categoryName"
                      :value="item.categoryId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="symptom"
                  label="部位及症状："
                  prop="symptom"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.symptom" placeholder="请输入部位及症状"></el-input>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="nextRepairTime"
                  label="下次登记时间："
                  prop="nextRepairTime"
                  :rules="$rules.required"
                >
                  <el-date-picker
                    v-model="form.nextRepairTime"
                    type="date"
                    format="yyyy-MM-dd"
                    size="medium"
                    class="width200"
                    placeholder="请选择下一次登记时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="recordTime"
                  label="开卡日期："
                  prop="recordTime"
                  :rules="$rules.required"
                >
                  <el-date-picker
                    v-model="form.recordTime"
                    type="date"
                    size="medium"
                    class="width200"
                    format="yyyy-MM-dd"
                    placeholder="请选择开卡日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="staffId"
                  label="技师名称："
                  prop="staffId"
                  :rules="$rules.changeIred"
                >
                  <el-select v-model="form.staffId" class="width200">
                    <el-option
                      v-for="(item,index) in staffList"
                      :key="index"
                      :label="item.staffName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add"
                  ref="remark"
                  label="备注："
                  prop="remark"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.remark" type="textarea" placeholder="请输入备注" maxlength="150" show-word-limit class="width200"></el-input>
                </el-form-item>
            
            <el-form-item label="登记照片（1-3张）" v-if="!form.id">
              
            </el-form-item>
            <imgUpload
                @file="getImgFile"
                :limit="3"
                :fileList="form.imgUrlList"
                @delete="deleteImgFile"
                :imgHide="imgHide"
                module="repair"
                v-if="!form.id"
              ></imgUpload>

          </el-form>
        </div>

        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button type="primary" class="small-btn" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import imgUpload from "../../../components/common/modules/upload";
export default {
  mixins: [minxin],
  components: { drawer, imgUpload },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {
        mobile: "",
        money: "",
        customerName: "",
        gender: "male",
        nextRepairTime: "",
        recordTime: "",
        imgUrlList: []
      },
      columns: [],
      staffList: [],
      categoryOption: [],
      cardOldName: "",
      showPicker: false,
      imgHide: true
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    getRepairItem() {
        this.$api.post(this.$url.repairDocument.listRepairItem).then(res => {
          if (res) this.categoryOption = res;
        })
    },
    back() {
      this.$refs["form"].resetFields()
      this.addEditShow = false;
      
    },
    getImgFile(res) {
      this.form.imgUrlList.push(res);
      if (this.form.imgUrlList.length >= 3) {
          this.imgHide = false
      }
    },
    deleteImgFile(res) {
      this.form.imgUrlList = res.myFileList;
      this.ossMerchatDelImg(res);
      if (this.form.imgUrlList.length < 3) {
          this.imgHide = true
      }
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.getRepairItem();
        if (org) {
          this.addEditTitle = "编辑纸质档案卡";
          this.$api.get(this.$url.paperRepairDocument.get, {id: org.id}).then(res => {
              if (res) {
                this.form = res;
                this.form.nextRepairTime = this.formatDay(this.form.nextRepairTime);
                this.form.repairCateId = this.form.categoryId;
                this.form.repairCateName = this.form.categoryName;
                this.form.recordTime = this.formatDay(this.form.recordTime);
                this.cardOldList();
              }
            })
            .catch(error => {});
        } else {
          this.addEditTitle = "新增纸质档案卡";
          this.cardOldList();
        }
        
        this.addEditShow = true;
      });
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    cardOldList() {
      this.$api.get(this.$url.companyStaff.list, {filterStatus: 'disable'})
        .then(res => {
          if (res) {
            this.staffList = res;
          }
        })
        .catch(error => {});
    },
    onSubmit(values) {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          if (!this.form.id && this.form.imgUrlList.length < 1) {
            return this.$message.error("请上传修护照片1-3张")
          }
          this.form.nextRepairTime = this.formatDay( this.form.nextRepairTime );
          this.form.recordTime = this.formatDay(this.form.recordTime);
          this.categoryOption.map(item => {
            if (item.categoryId == this.form.repairCateId) {
              this.form.repairCateName = item.categoryName;
            }
          })
          this.staffList.map(items => {
            if (items.id == this.form.staffId) {
              this.form.staffName = items.staffName;
            }
          })
          this.$api.post(this.$url.paperRepairDocument.save, this.form)
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0 16px;
  height: 100%;
  box-sizing: border-box;
  .el-form-item-add {
    display: flex;

  }
  /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
}
</style>